import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../utils/httpCommon";

const responseInitialState = {
    message: '',
    title: 'Ha ocurrido un error',
    status: 'error'
}

const initialState = {
    loading: false,
    error: '',
    response: responseInitialState
}

export const createUser = createAsyncThunk('user/create', async (user: UserCreate) => {

    return await http.post('/user', user)
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            throw new Error(error.response.data.message)
        })
})

const userSlice = createSlice({
    name: 'userCreate',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder
            .addCase(createUser.pending, (state, action) => {
                
                state.loading = true
                state.error = ''
                state.response = responseInitialState
            })
            .addCase(createUser.fulfilled, (state, action) => {
               
                state.loading = false

                if (!action.payload.success)
                    state.error = action.payload.message
                else {
                    state.response.message = action.payload.object.messages
                    state.response.title = action.payload.object.title
                    state.response.status = action.payload.object.status
                }
            })
            .addCase(createUser.rejected, (state, action) => {

                state.loading = false
                state.error = action.error.message!.toString()
            })
    }
})

export default userSlice.reducer;